var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTotalPhotoIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 54,
    viewBox: "0 0 55 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 12.7507C16.5 11.1593 17.1322 9.63294 18.2576 8.50758C19.3829 7.38222 20.9093 6.75 22.5007 6.75H41.9993C42.7873 6.75 43.5676 6.90521 44.2956 7.20678C45.0237 7.50835 45.6852 7.95036 46.2424 8.50758C46.7996 9.0648 47.2417 9.72632 47.5432 10.4544C47.8448 11.1824 48 11.9627 48 12.7507V32.2493C48 33.0373 47.8448 33.8176 47.5432 34.5456C47.2417 35.2737 46.7996 35.9352 46.2424 36.4924C45.6852 37.0496 45.0237 37.4917 44.2956 37.7932C43.5676 38.0948 42.7873 38.25 41.9993 38.25H22.5007C20.9093 38.25 19.3829 37.6178 18.2576 36.4924C17.1322 35.3671 16.5 33.8407 16.5 32.2493V12.7507Z",
    stroke: "#7C7C7D",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.777 16.335C9.08702 16.7283 8.51311 17.2968 8.11329 17.9831C7.71347 18.6693 7.50192 19.449 7.5 20.2432V42.7432C7.5 45.2182 9.525 47.2432 12 47.2432H34.5C36.1875 47.2432 37.1055 46.377 37.875 44.9932",
    stroke: "#7C7C7D",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39 15.75H39.0217",
    stroke: "#7C7C7D",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 29.25L24.699 21.051C24.9518 20.7979 25.2521 20.5971 25.5826 20.4602C25.913 20.3232 26.2673 20.2527 26.625 20.2527C26.9827 20.2527 27.337 20.3232 27.6674 20.4602C27.9979 20.5971 28.2982 20.7979 28.551 21.051L36.75 29.25",
    stroke: "#7C7C7D",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5 27L38.199 23.301C38.4518 23.0479 38.7521 22.8471 39.0826 22.7102C39.413 22.5732 39.7673 22.5027 40.125 22.5027C40.4827 22.5027 40.837 22.5732 41.1674 22.7102C41.4979 22.8471 41.7982 23.0479 42.051 23.301L48 29.25",
    stroke: "#7C7C7D",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalPhotoIcon);
export default __webpack_public_path__ + "static/media/totalPhotoIcon.a5f723d1e3731e752ee82fd927cb76b3.svg";
export { ForwardRef as ReactComponent };